export default __webpack_public_path__ + "static/clock-fdc24b13a755ee8e00ceee73b9c01c81.svg";